/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_bZ_98_90 as Componente_bZ_98_90,
  rec_Componente_xZ_120_90 as Componente_xZ_120_90,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lr as Lr,
  rec_NuevoAccesoMovilidad as NuevoAccesoMovilidad,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_cZ as cZ,
  rec_ra as ra,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function AccesosMovilidad() {
  let e = Go(),
    { confirmar: t } = Fo(),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)(!0),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(!1),
    u = (0, React.useCallback)(async () => {
      a(!0);
      try {
        (r(await api(`/transporte/enlaces`)), s(``));
      } catch (e) {
        s(e.message);
      } finally {
        a(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    u();
  }, [u]);
  async function f(t) {
    try {
      (await navigator.clipboard.writeText(t.url), e.ok(`Enlace copiado`));
    } catch {
      e.error(`No se pudo copiar. Abrilo desde otra ventana y copialo a mano`);
    }
  }
  async function p(n) {
    if (
      await t({
        titulo: `Dar de baja el de ${n.nombre}`,
        mensaje: `Su planilla deja de actualizarse. Las de los demás siguen igual.`,
        confirmarTexto: `Dar de baja`,
        peligro: !0,
      })
    )
      try {
        (await api(`/transporte/enlaces/${n.id}/baja`, {
          method: `POST`,
        }),
          r((e) =>
            e.map((e) =>
              e.id === n.id
                ? {
                    ...e,
                    activo: !1,
                    url: null,
                  }
                : e,
            ),
          ),
          e.ok(`El enlace de ${n.nombre} ya no funciona`));
      } catch (t) {
        e.error(t.message);
      }
  }
  return (
    <div
      className={`flex flex-col gap-3`}
      children={[
        <EstadoError mensaje={o} onReintentar={u} />,
        <p
          className={`text-sm text-(--text)`}
          children={`Cada persona se lleva los pedidos a su Excel con su propio enlace. Si uno se filtra, se da de baja ese y los demás siguen andando.`}
        />,
        <div
          className={`flex justify-end`}
          children={
            <button
              type={`button`}
              onClick={() => l(!0)}
              className={zo}
              children={[
                <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                ` Nuevo acceso`,
              ]}
            />
          }
        />,
        i ? (
          <Componente_bZ_98_90 />
        ) : n.length === 0 ? (
          <Componente_xZ_120_90
            texto={`Todavía no hay accesos. Creá uno para que Transporte se lleve los pedidos a Excel.`}
          />
        ) : (
          <ul
            className={`flex flex-col gap-2`}
            children={n.map((e) => (
              <li
                key={e.id}
                className={`${Bo} flex items-center gap-3`}
                children={[
                  <div
                    className={`min-w-0 flex-1`}
                    children={[
                      <p
                        className={`truncate text-sm text-(--text-h)`}
                        children={e.nombre}
                      />,
                      <p
                        className={`text-xs text-(--text)`}
                        children={[
                          `Último uso: `,
                          cZ(e.ultimoUsoEn),
                          ` · `,
                          e.usos,
                          ` `,
                          e.usos === 1 ? `vez` : `veces`,
                        ]}
                      />,
                    ]}
                  />,
                  !e.activo && (
                    <span
                      className={`rounded-full bg-(--panel) px-2 py-0.5 text-[10px] uppercase text-(--text)`}
                      children={`de baja`}
                    />
                  ),
                  e.activo && (
                    <JSXRuntime.Fragment
                      children={[
                        <button
                          type={`button`}
                          onClick={() => f(e)}
                          aria-label={`Copiar el enlace de ${e.nombre}`}
                          className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                          children={<Lr className={`h-3.5 w-3.5`} />}
                        />,
                        <button
                          type={`button`}
                          onClick={() => p(e)}
                          aria-label={`Dar de baja el enlace de ${e.nombre}`}
                          className={`rounded-lg p-2 text-(--text) hover:bg-(--error-bg) hover:text-(--error)`}
                          children={(0, JSXRuntime.jsx)(ra, {
                            className: `h-3.5 w-3.5`,
                          })}
                        />,
                      ]}
                    />
                  ),
                ]}
              />
            ))}
          />
        ),
        c && (
          <NuevoAccesoMovilidad
            onClose={() => l(!1)}
            onCreado={(e) => {
              (l(!1), r((t) => [e, ...t]));
            }}
          />
        ),
      ]}
    />
  );
}
